import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-600 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <Logo className="w-12 h-12 brightness-0 invert" />
              <span className="text-2xl font-bold">TYJ Group</span>
            </div>
            <div className="space-y-4 opacity-90">
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 mt-1">
                  <div className="w-3 h-3 bg-pink-400 rounded-full animate-pulse"></div>
                </div>
                <span className="text-sm">Leading provider of digital transformation and mobility solutions</span>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-xl font-bold mb-6">Company</h3>
            <ul className="space-y-3">
              {['About Us', 'Services', 'Careers', 'Contact', 'Blog'].map((item) => (
                <li key={item}>
                  <button className="hover:text-pink-200 transition-colors text-left opacity-90 hover:opacity-100">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Address</h3>
            <div className="space-y-4 opacity-90">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  V05-05-01, Signature L,<br />
                  V05 Lingkaran SV,<br />
                  Sunway Velocity, 55100,<br />
                  Federal Territory of Kuala Lumpur
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5" />
                <a href="mailto:contactus@tyjgroup.com" className="text-sm hover:text-pink-200 transition-colors">
                  contactus@tyjgroup.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5" />
                <a href="tel:+60193688882" className="text-sm hover:text-pink-200 transition-colors">
                  +60 19-368 8882
                </a>
              </div>
              
              {/* Social Links */}
              <div className="flex space-x-4 pt-4">
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="#"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-sm opacity-90">
            <p>Copyright © 2026 TYJ GROUP SOLUTIONS Sdn. Bhd. All rights reserved.</p>
            <div className="flex space-x-6">
              <button className="hover:text-pink-200 transition-colors">Terms of Use</button>
              <span>|</span>
              <button className="hover:text-pink-200 transition-colors">Privacy Policy</button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
